module.exports = __webpack_public_path__ + "media/icons/facebook-circle-c035eb1f.svg";